import { apiFetch } from '@/shared/api/client'

/** Baris material pada retur dapur→gudang (§5.4–5.5 slice 2b). */
export type MaterialReturnLine = {
  id: string
  material_id: string
  material_name: string
  uom: string
  qty_kitchen: number
}

/** Satu retur pada GET /warehouse/material-returns/today. */
export type MaterialReturnTodayItem = {
  id: string
  code: string
  kitchen_name: string
  status: string
  picked_up_at?: string
  lines: MaterialReturnLine[]
}

export type TodayMaterialReturnsResponse = {
  returns: MaterialReturnTodayItem[]
}

export type ScanMaterialReturnPickupResponse = {
  return_id: string
  return_code: string
  kitchen_name: string
  status: string
  picked_up_at: string
  lines: MaterialReturnLine[]
}

export type MaterialReturnReceiveLineInput = {
  material_id?: string
  material_code?: string
  qty_received: number
  uom: string
}

export type MaterialReturnReceiveResponse = {
  return_id: string
  return_code: string
  status: string
  validated_at: string
}

/** POST /warehouse/material-returns/scan-pickup — scan QR SUPEROTI:WRH:… */
export async function scanMaterialReturnPickup(token: string): Promise<ScanMaterialReturnPickupResponse> {
  return apiFetch<ScanMaterialReturnPickupResponse>('/warehouse/material-returns/scan-pickup', {
    method: 'POST',
    body: JSON.stringify({ token: token.trim() }),
  })
}

/** GET /warehouse/material-returns/today — retur brand/gudang hari ini. */
export async function fetchTodayMaterialReturns(): Promise<MaterialReturnTodayItem[]> {
  const res = await apiFetch<TodayMaterialReturnsResponse>('/warehouse/material-returns/today')
  return res.returns ?? []
}

/** POST /warehouse/material-returns/{ref}/receive — terima di gudang + PIN delman. */
export async function receiveMaterialReturn(
  returnRef: string,
  pin: string,
  lines: MaterialReturnReceiveLineInput[],
): Promise<MaterialReturnReceiveResponse> {
  return apiFetch<MaterialReturnReceiveResponse>(
    `/warehouse/material-returns/${encodeURIComponent(returnRef)}/receive`,
    {
      method: 'POST',
      body: JSON.stringify({ pin, lines }),
    },
  )
}
